import React from 'react';
import { useSeoMeta } from '../../hooks/useSeoMeta';

export const Head = ({ location = { pathname: `/` }, seo = {} }) => {
  const {
    site: {
      siteMetadata: { siteUrl, title: siteTitle }
    },
    strapiDefaultSeo
  } = useSeoMeta();

  const defaultSeo = strapiDefaultSeo?.seo || {};

  const tags = {
    title: seo.metaTitle || seo.pageMetaTitle || defaultSeo.metaTitle,
    canonical: siteUrl + location.pathname,
    description: seo.metaDescription || defaultSeo.metaDescription || ``,
    keywords: seo.keywords || defaultSeo.keywords || ``,
    robots: seo.metaRobots || defaultSeo.metaRobots || ``,
    noIndex: seo.noIndex || ``,
    image:
      seo?.metaImage?.localFile?.childImageSharp?.fluid?.src ||
      defaultSeo?.metaImage?.localFile?.childImageSharp?.fluid?.src ||
      ``,
    imageAlt:
      seo?.metaImage?.alternativeText ||
      defaultSeo?.metaImage?.alternativeText ||
      ``
  };

  const noIndex = typeof tags.noIndex === `boolean` && tags.noIndex === true;

  const params =
    typeof document !== `undefined`
      ? new URLSearchParams(document.location.search)
      : null;

  const filter = params ? params.get(`filter`) : null;
  const hasParams = filter !== null || filter?.length > 0;

  return (
    <>
      <title>{`${tags.title}`}</title>

      {(noIndex || hasParams) && (
        <meta name="robots" content="noindex, nofollow" />
      )}

      <link rel="canonical" href={tags.canonical} />
      <meta name="description" content={tags.description} />
      <meta name="keywords" content={tags.keywords} />
      <meta
        name="viewport"
        content="width=device-width,minimum-scale=1.0,initial-scale=1.0,maximum-scale=5.0,viewport-fit=cover"
      />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:title" content={tags.title} />
      <meta property="og:description" content={tags.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={tags.canonical} />
      <meta property="og:image" content={tags.image} />
      <meta name="twitter:title" content={tags.title} />
      <meta name="twitter:description" content={tags.description} />
      <meta name="twitter:image" content={tags.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image:alt" content={tags.imageAlt} />
    </>
  );
};

export default Head;
